var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentViewGridFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.692 2.59h6.116c.382 0 .692.31.692.693V9.4c0 .382-.31.692-.692.692H3.692A.692.692 0 013 9.399V3.283c0-.382.31-.692.692-.692zm10.558 0h6.058c.382 0 .692.31.692.693V9.4c0 .382-.31.692-.692.692H14.25a.692.692 0 01-.692-.692V3.283c0-.382.31-.692.692-.692zM9.808 13.149H3.692A.692.692 0 003 13.84v6.057c0 .383.31.693.692.693h6.116c.382 0 .692-.31.692-.693V13.84a.692.692 0 00-.692-.692zm4.442 0h6.058c.382 0 .692.31.692.692v6.057c0 .383-.31.693-.692.693H14.25a.692.692 0 01-.692-.693v-6.057c0-.382.31-.692.692-.692z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentViewGridFill);
export default __webpack_public_path__ + "d7009f90a91707cd8df12783513916e0.svg";
export { ForwardRef as ReactComponent };